import React, { ReactNode } from "react";
import styled from "@emotion/styled";
import { Box, Theme, useMediaQuery } from "@mui/material";
import {
  ComparisonValue,
  SelectCompare,
} from "@components/Chart/BaseChartTools";

const InvestmentChartBottomBarWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isStacked" && prop !== "hasComponent",
})<{
  isStacked: boolean;
  hasComponent: boolean;
}>(({ theme, isStacked, hasComponent }) => ({
  display: "flex",
  width: "100%",
  gap: theme.spacing(2),
  flexDirection: isStacked ? "column" : "row",
  justifyContent: hasComponent ? "space-between" : "flex-end",
  alignItems: isStacked ? "stretch" : hasComponent ? "flex-end" : "center",
}));

const RightSide = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "flex-end",
  flexShrink: 0,
  width: 320,

  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
}));

interface InvestmentChartBottomBarProps {
  selectedComparedValue?: ComparisonValue | null;
  onComparedValueChange?: (value?: ComparisonValue) => void;
  disabled?: boolean;
  bottomBarComponent?: ReactNode;
  showComparisonSelector?: boolean;
}

export const InvestmentChartBottomBar = ({
  selectedComparedValue = null,
  disabled,
  onComparedValueChange,
  bottomBarComponent,
  showComparisonSelector = true,
}: InvestmentChartBottomBarProps) => {
  const isMd = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

  const hasComponent = Boolean(bottomBarComponent);

  if (!hasComponent && !showComparisonSelector) {
    return null;
  }

  return (
    <InvestmentChartBottomBarWrapper
      isStacked={isMd}
      hasComponent={hasComponent}
    >
      {bottomBarComponent}
      {showComparisonSelector && (
        <RightSide>
          <SelectCompare
            disabled={disabled}
            value={selectedComparedValue}
            onChange={(value) => onComparedValueChange?.(value)}
          />
        </RightSide>
      )}
    </InvestmentChartBottomBarWrapper>
  );
};
